/**
 * Make a deep copy of an object
 * @param {*} data The object to deep copy
 */
export function DeepCopy(data) {
    return JSON.parse(JSON.stringify(data))
}